import {
    SEND_EMAIL_REQUEST, SEND_EMAIL_ERROR, SEND_EMAIL_SUCCESS, SET_TOKEN,
    VERIFY_EMAIL_REQUEST, VERIFY_EMAIL_VERIFIED, VERIFY_EMAIL_NOT_VERIFIED, VERIFY_EMAIL_ERROR, LOGOUT, INCREASE_LOCAL_INCREMENT,
    LOGIN_USER_SOCIAL, SET_LOCAL_INCREMENT, SET_ME
} from "./actions";
import {REHYDRATE} from 'redux-persist/'


const initialState = {
    'token': null,
    'deviceId': null,
    'isSendingEmail': false,
    'isEmailSent': false,
    'isVerifyingEmail': false,
    'isVerified': false,
    'localIncrement': 1,
    'email': null,
    'me': null,
};

function authReducer(state = initialState, action) {
    switch(action.type) {
        case SEND_EMAIL_REQUEST:
             return {...state, isSendingEmail: true };
        case SEND_EMAIL_SUCCESS:
            return {...state, isSendingEmail: false, isEmailSent: true, token: action.payload.device_token, deviceId: action.payload.device_id, email: action.email};
        case SEND_EMAIL_ERROR:
            return {...state, isSendingEmail: false };
        case SET_TOKEN:
            return {...state, token: action.token};
        case VERIFY_EMAIL_REQUEST:
            return {...state, isVerifyingEmail: true};
        case VERIFY_EMAIL_VERIFIED:
            return {...state, isVerifyingEmail: false, isVerified: true};
        case VERIFY_EMAIL_NOT_VERIFIED:
            return {...state, isVerifyingEmail: false, isVerified: false};
        case VERIFY_EMAIL_ERROR:
            return {...state, isVerifyingEmail: false};
        case LOGIN_USER_SOCIAL:
            return {...state, isVerified: true, token: action.payload.device_token, deviceId: action.payload.device_id};
        case REHYDRATE:
            if (action.payload) {
                const incoming = action.payload.auth;
                return {...state, token: incoming.token, isVerified: incoming.isVerified, localIncrement: incoming.localIncrement, deviceId: incoming.deviceId, email: incoming.email};
            }
            return state;
        case LOGOUT:
            return {...initialState};
        case INCREASE_LOCAL_INCREMENT:
            return {...state, localIncrement: state.localIncrement + 1};
        case SET_LOCAL_INCREMENT:
            return {...state, localIncrement: action.value}
        case SET_ME:
            return {...state, me: action.payload}
        default:
            return state
    }

}

export default authReducer;


// WEBPACK FOOTER //
// ./src/store/auth/reducer.js